/**
 * @class
 */
import Base from './attribute';

import {ids as attributeTypeIds} from '@netx/core-asset/properties/attributes';

export default class Attribute_Text extends Base {
	/** @type {object} */
	get defaults() {
		return {
			...super.defaults,
			type: attributeTypeIds.text,
		};
	}

	/**
	 * @override
	 * @param {mixed} value Value
	 * @param {object} opts Options
	 * @return {mixed} Formatted value
	 */
	format(value, opts) {
		opts = opts || {};

		const parsedInValue = this.parseInValue(value);
		value = parsedInValue != null ? parsedInValue : '';

		var parseURL = opts.parseURL !== false,
			truncateAt = opts.truncateAt;

		if (_.isArray(value)) {
			value = value.join(', ');
		}

		value = value.replace(/</g, '&lt;');
		value = value.replace(/>/g, '&gt;');

		// Truncate value
		if (truncateAt && truncateAt !== Infinity && value.length > truncateAt) {
			var truncatedValue = value.substr(0, truncateAt).trim();

			if (parseURL) {
				var urls = value.match(/(https?:\/\/.*?[^\s]+)/g);
				// We need to check if any urls started prior to truncation that did not complete
				// before truncation
				if (urls) {
					var valLength = truncatedValue.length,
						cutoffUrl,
						c,
						i,
						idx;

					for (i = 0, c = urls.length; i < c; i++) {
						const url = urls[i];
						idx = value.lastIndexOf(url);
						if (idx < valLength && idx + url.length > valLength) {
							cutoffUrl = url;
							break;
						}
					}

					truncatedValue = cutoffUrl
						? _.parseURLS(truncatedValue.substr(0, idx)) +
						  '<a title="' +
						  cutoffUrl +
						  '" target="_blank" rel="noopener" href="' +
						  cutoffUrl +
						  '">' +
						  truncatedValue.substr(idx) +
						  '</a>'
						: _.parseURLS(truncatedValue);
				}
			}

			return truncatedValue + '...';
		}

		return parseURL ? _.parseURLS(value) || '' : value;
	}

	/**
	 * Value only appendable if not a multivalue attribute
	 * @override
	 * @return {boolean} Value is appendable
	 */
	isAppendable() {
		return !this.isTrueMultivalue();
	}

	/** @type {string} */
	static get __name__() {
		return 'Attribute_Text';
	}
}
